import { Filters } from 'types/filters';

import { AppModules } from 'constants/enums';
import { GRID_TABLE_PAGING_VALUES } from 'constants/uiSettings';

const MODULE_PAGE_SIZE_OPTIONS: Partial<Record<AppModules, number[]>> = {
  [AppModules.Jobseekers]: GRID_TABLE_PAGING_VALUES
};

export const normalizePageSizeForModule = (
  module: AppModules,
  pageSize: number | undefined
): number | undefined => {
  const allowedPageSizes = MODULE_PAGE_SIZE_OPTIONS[module];

  if (!allowedPageSizes || pageSize === undefined) {
    return pageSize;
  }

  return allowedPageSizes.includes(pageSize) ? pageSize : allowedPageSizes[0];
};

export const cleanFilters = (filters: Partial<Filters>): Partial<Filters> => {
  return Object.entries(filters).reduce((acc, [key, value]) => {
    if (value !== undefined && value !== null) {
      // @ts-ignore
      acc[key] = value;
    }
    return acc;
  }, {} as Partial<Filters>);
};

export const hasSignificantFilterChanges = (
  oldFilters: Partial<Filters>,
  newFilters: Partial<Filters>
): boolean => {
  const allKeys = new Set([
    ...Object.keys(oldFilters),
    ...Object.keys(newFilters)
  ]);

  return Array.from(allKeys).some((key) => {
    const field = key as keyof Filters;
    return oldFilters[field] !== newFilters[field];
  });
};
